import React, { ComponentProps } from 'react'
import { Button } from 'react-native-paper'
import { Text, View } from 'react-native'
import { theme } from '@linqpal/common-frontend'
import {
  composeStyle,
  webSpecificStyle,
} from '@linqpal/common-frontend/src/helpers'
import { IconCloseCross } from '../../assets/icons'
import { GetIcon } from '../atoms/GetIcon'
import SModal from './SModal'

const { commonColors } = theme

const OptionButton = ({
  title,
  bgColor = commonColors.accentText,
  mode = undefined,
  onPress,
  labelStyle = {},
  contentStyle,
  style,
  ...props
}) => {
  return (
    <Button
      mode={mode}
      uppercase={false}
      style={{ backgroundColor: bgColor, width: '100%', ...style }}
      onPress={onPress}
      contentStyle={composeStyle(
        !props.compact && { height: 48, width: 150 },
        contentStyle,
      )}
      theme={{ roundness: 8 }}
      labelStyle={composeStyle(
        { fontSize: 16, padding: 2, fontWeight: '500', color: 'white' },
        webSpecificStyle({ userSelect: 'none' }),
        labelStyle,
      )}
    >
      {title}
    </Button>
  )
}

export const SuccessFailurePrompt = ({
  visible = false,
  icon,
  onDismiss,
  height = undefined,
  linkData,
  textContentBottomMargin = 45,
  title,
  message,
  buttonData,
  contentContainerStyle = {},
  exitable = true,
  footer = null,
}: ComponentProps<any>) => {
  return visible ? (
    <SModal
      visible={visible}
      modalStyle={{ justifyContent: 'flex-end' }}
      onClose={onDismiss}
      containerStyle={{
        backgroundColor: 'white',
        height,
        minWidth: 300,
        borderRadius: 20,
        marginHorizontal: 20,
        padding: 0,
        display: 'flex',
        justifyContent: 'flex-start',
        ...contentContainerStyle,
      }}
    >
      <View
        style={{
          backgroundColor: 'white',
          width: 340,
          borderRadius: 20,
          paddingBottom: 20,
        }}
      >
        {exitable && (
          <View
            style={{ flexDirection: 'row', justifyContent: 'space-between' }}
          >
            {/* Dummy to get spacing correct */}
            <View style={{ height: 40, paddingLeft: 15, paddingTop: 15 }}>
              <GetIcon
                style={{ visibility: 'hidden' }}
                icon={<IconCloseCross height="14" width="14" />}
                onPress={onDismiss}
              />
            </View>
            {/* Dummy to get spacing correct */}
            {icon}
            <View style={{ height: 40 }}>
              <GetIcon
                icon={<IconCloseCross height="14" width="14" />}
                onPress={onDismiss}
                style={undefined}
              />
            </View>
          </View>
        )}
        {!exitable && <View style={{ alignSelf: 'center' }}>{icon}</View>}
        <View
          style={{
            padding: 0,
            alignItems: 'center',
            marginBottom: textContentBottomMargin,
          }}
        >
          <Text
            style={{
              fontSize: 18,
              fontWeight: '600',
              textAlign: 'center',
              marginVertical: 22,
            }}
          >
            {title}
          </Text>
          <Text
            style={{
              fontSize: 16,
              fontWeight: '400',
              textAlign: 'center',
              width: '90%',
              marginTop: 18,
              color: commonColors.textLight,
              lineHeight: 26,
            }}
          >
            {message}
          </Text>
        </View>
        {footer}
        <View style={{ flexDirection: 'row', justifyContent: 'space-evenly' }}>
          {buttonData && (
            <OptionButton
              title={buttonData.title}
              onPress={buttonData.onPress}
              style={buttonData?.style}
              contentStyle={buttonData?.contentStyle}
            />
          )}
        </View>
        {linkData && (
          <View style={{ marginTop: 21, width: '100%', alignItems: 'center' }}>
            <Text style={{ fontWeight: '500', fontSize: 16 }}>
              {linkData.text}
            </Text>
          </View>
        )}
      </View>
    </SModal>
  ) : null
}
